import firebase from 'firebase'
import { firebaseAction } from 'vuexfire'


const state = {
  mine: null
}
const getters = {
  mine: (state) => state.mine
}
const actions = {
  bind: firebaseAction(({ bindFirebaseRef }, profile) => {
    if (profile && profile.company) {
      bindFirebaseRef('mine', firebase.firestore().doc(profile.company))
    }
  })
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/companies.js